let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("yv6XD")).then(() => parcelRequire('1I9qh'));